import { render } from "./FaceEnrollment.vue?vue&type=template&id=2f7fe222&scoped=true"
import script from "./FaceEnrollment.vue?vue&type=script&lang=js"
export * from "./FaceEnrollment.vue?vue&type=script&lang=js"

import "./FaceEnrollment.vue?vue&type=style&index=0&id=2f7fe222&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7fe222"]])

export default __exports__